<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     商品详情预览组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="preview-product">
    <div class="scrollView">
      <div class="box">
        <img v-if="pics.length" :src="pics[index].url" class="head-img" />
        <img v-else src="@/assets/no-cover.png" class="head-img" />
        <div v-if="pics.length" class="left_arrow" @click="prePic()"></div>
        <div v-if="pics.length" class="right_arrow" @click="nextPic()"></div>
        <div v-if="pics.length" class="direction"><span> {{ index + 1 }} / {{ pics.length }}</span></div>
      </div>

      <div class="preview_bd">
        <div class="product-price mt-sm">
          <span class="unit">¥</span>
          <span v-if="skuInfo.length > 0">{{ salePrice }}</span>
          <span v-else-if="defaultSkuInfo.sale_price">{{ defaultSkuInfo.sale_price }}</span>
          <span v-else>-</span>
        </div>
        <div class="product-hd">
          <div class="product-name">{{ good.title }}</div>
          <div class="product-des">{{ good.sub_title }}</div>
          <div v-if="isGodid1" class="sku-extra mt-xs text-muted">
            <span class="mr-xs">库存</span>{{ skuInfo.length > 0 ? skuInfo[0].stock_num : defaultSkuInfo.stock_num ? defaultSkuInfo.stock_num : 0 }}
          </div>
        </div>
        <div class="product-cell">
          <div class="cell-des flex" role="button" @click="shippingTemplate.templateid ? shippingShow = true : ''">
            <div class="cell_hd mr text-muted">发货</div>
            <div class="cell_bd">
              <div class="cell-title">{{ shippingTemplate.name || '包邮' }}</div>
            </div>
            <div class="cell_ft"></div>
          </div>
          <div class="cell-des flex" role="button" @click="show = true">
            <div class="cell_hd mr text-muted">选择</div>
            <div class="cell_bd">
              <div class="cell-title">
                <span v-for="(param, index) in params" :key="index" class="mr-xs">
                  {{ param.attr_key }}
                </span>
              </div>
            </div>
            <div class="cell_ft"></div>
          </div>
          <div v-for="(item, index) in resources" :key="item.resourceid" class="cell-des flex" role="button">
            <div class="cell_hd mr text-muted">商品资料{{ resources.length > 1 ? index + 1 : '' }}</div>
            <div v-overflow-tooltip="1" class="cell_bd ellipsis">
              <div class="cell-title ellipsis">{{ item.title }}</div>
            </div>
            <div class="cell_ft"></div>
          </div>
        </div>
        <div class="product-bd">
          <div class="product-details">
            <div class="detail-title text-muted">商品详情</div>
            <div class="detail-des">{{ desc.desc }}</div>
            <template v-if="details.length">
              <img v-for="(item, index) in details" :key="index" :src="item.url" />
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="skuDialog dialog" :class="{ 'view-show': show }">
      <div class="mask"></div>
      <div class="dialog_container">
        <div class="container-title">
          <div class="closeBtn" @click="show = false"></div>
        </div>
        <div class="dialog__content">
          <div class="sku-dialog__hd">
            <div class="flex sku-preview">
              <img v-if="pics.length" :src="pics[0].url" class="sku-preview__image">
              <img v-else src="@/assets/no-cover.png" class="sku-preview__image">
              <div class="sku-preview__info">
                <div class="product-title">{{ good.title }}</div>
                <div class="product-sub-title mt-xs">{{ good.sub_title }}</div>
                <div class="sku-price">
                  ￥<span v-if="skuInfo.length > 0" class="price-num">{{ salePrice }}</span>
                  <span v-else-if="defaultSkuInfo.sale_price" class="price-num">{{ defaultSkuInfo.sale_price }}</span>
                  <span v-else class="price-num">-</span>
                </div>
              </div>
            </div>
          </div>
          <div class="sku-dialog__bd">
            <div class="sku-list">
              <div v-for="(param, index) in params" :key="index" class="sku-item pt pb">
                <div class="sku-item__title mb-sm text-muted">{{ param.attr_key }}</div>
                <div class="sku-item__tags flex">
                  <div v-for="(item, param_index) in param.attr_info" :key="param_index" class="sku-item__tag" :class="{ 'active': item.active === 1 }">
                    {{ item.attr_value }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isGodid1" class="sku-count flex align-items-center">
              <div class="sku-count__hd" style="flex: 1;">数量 <span v-if="good.is_limit" class="limit-num">（限购{{ good.limit_num }}件）</span></div>
              <div class="count-ctrl">
                <div class="count-ctrl__btn">
                  <i class="el-icon-remove-outline"></i>
                </div>
                <div class="count-ctrl__input ml-sm mr-sm">
                  <span>1</span>
                </div>
                <div class="count-ctrl__btn">
                  <i class="el-icon-circle-plus-outline"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="shipping-dialog dialog" :class="{ 'view-show': shippingShow }">
      <div class="mask"></div>
      <div class="dialog_container">
        <div class="container-title">
          <div class="closeBtn" @click="shippingShow = false"></div>
          <div class="title-text text-bold">发货</div>
        </div>
        <div class="dialog__content pl-sm pr-sm pt-sm">
          <div class="shipping-cell flex align-items-center pt-xs pb-xs">
            <div class="cell-title">发货时效</div>
            {{ ship }}
          </div>
          <div class="shipping-cell flex align-items-center pt-xs pb-xs">
            <div class="cell-title">默认运费</div>
            {{ shippingTemplate.default_freight }}
          </div>
          <div v-if="shippingTemplate.calc_freight" class="shipping-cell flex align-items-center pt-xs pb-xs">
            <div class="cell-title">指定运费</div>
            {{ shippingTemplate.calc_freight }}
          </div>
          <div class="shipping-cell flex align-items-center pt-xs pb-xs">
            <div class="cell-title">不配送地区</div>
            {{ shippingTemplate.no_send_area_freight }}
          </div>
        </div>
      </div>
    </div>

    <div class="preview_ft">
      <div class="page-ft__content" :class="{contentBorder: !(show || shippingShow)}">
        <div class="flex" style="flex: 1;">
          <div v-if="!(show || shippingShow)" class="tab-item">
            <div class="tab-item__icon msg"></div>
            <div class="tab-item__text">客服</div>
          </div>
        </div>
        <div v-if="isGodid1 && !shippingShow" class="ft-btn buy-btn">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PreviewProduct',

  props: {
    pics: {
      type: Array,
      default: []
    },
    params: {
      type: Array,
      default: []
    },
    details: {
      type: Array,
      default: []
    },
    good: {
      type: Object,
      default: {}
    },
    skuInfo: {
      type: Array,
      default: []
    },
    defaultSkuInfo: {
      type: Object,
      default: []
    },
    desc: {
      type: Object,
      default: {}
    },
    shippingTemplate: {
      type: Object,
      default: {}
    },
    onlineDocument: {
      type: Array,
      default: []
    },
    resourceids: {
      type: Array,
      default: []
    }
  },

  data () {
    return {
      show: true,
      shippingShow: false,
      index: 0
    }
  },

  created () {
  },

  computed: {
    deliveryTimeTypeObj() {
      return this.$store.getters.deliveryTimeTypeObj;
    },
    ship() {
      let ship = ''
      if (this.shippingTemplate.templateid) {
        ship = this.deliveryTimeTypeObj[this.shippingTemplate.delivery_time_type].value
      }

      return ship
    },
    salePrice() {
      let maxPrice = this.skuInfo[0].sale_price
      let minPrice = this.skuInfo[0].sale_price
      for (let i = 1; i < this.skuInfo.length; i++) {
        if (this.skuInfo[i].sale_price > maxPrice) {
          maxPrice = this.skuInfo[i].sale_price
        }
        if (this.skuInfo[i].sale_price < minPrice) {
          minPrice = this.skuInfo[i].sale_price
        }
      }

      return maxPrice === minPrice ? maxPrice : `${minPrice}~${maxPrice}`
    },
    resources() {
      return this.onlineDocument.filter(item => this.resourceids.includes(item.resourceid))
    },
    isGodid1() {
      return this.$store.state.godStore.godid == 1;
    }
  },

  methods: {
    prePic () {
      if (this.index === 0) {
        this.index = this.pics.length - 1
      } else {
        this.index--
      }
    },
    nextPic () {
      if (this.index === this.pics.length - 1) {
        this.index = 0
      } else {
        this.index++
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.preview-product {
  position: sticky;
  top: 32px;
  overflow: hidden;
  // border: 2px solid #fff;
  border-radius: 24px;
  width: 375px;
  height: 812px;
  background-color: #f6f7f8;
  box-sizing: border-box;
  box-shadow: 4px 6px 12px rgba(200, 200, 200, 10%);
  .scrollView {
    position: relative;
    height: 812px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 64px;
    .box {
      position: relative;
      .head-img {
        width: 375px;
        height: 375px;
        object-fit: cover;
      }
      .left_arrow {
        cursor: pointer;
        position: absolute;
        bottom: 50px;
        left: 30px;
        display: inline-block;
        vertical-align: middle;
        width: 45px;
        height: 45px;
        background-size: cover;
        background-image: url('../../../assets/left-arrow.svg');
      }
      .right_arrow {
        cursor: pointer;
        position: absolute;
        bottom: 50px;
        right: 30px;
        display: inline-block;
        vertical-align: middle;
        width: 45px;
        height: 45px;
        background-size: cover;
        background-image: url('../../../assets/right-arrow.svg');
      }
      .direction {
        position: absolute;
        bottom: 16px;
        right: 16px;
        font-size: 14px;
        color: #aaa;
      }
    }
    .preview_bd {
      .product-price {
        height: 30px;
        display: flex;
        align-items: flex-end;
        padding: 0 16px;
        font-size: 24px;
        font-weight: 600;
        line-height: 28px;
        margin-right: 4px;
        color: #ffc107;
        .unit {
          font-size: 18px;
          margin-right: 10px;
        }
      }
      .product-hd {
        padding: 4px 16px 16px;
        .product-name {
          font-size: 18px;
          font-weight: bold;
        }
        .product-des {
          margin-top: 4px;
        }
      }
      .product-cell {
        .cell-des {
          padding: 16px;
          border-top: 0.5px solid rgba(0, 0, 0, 0.05);
          .cell_bd {
            flex: 1;
          }
          .cell_ft:after {
            margin-top: -2px;
            top: 0;
            content: ' ';
            display: inline-block;
            vertical-align: middle;
            width: 12px;
            height: 24px;
            background-size: cover;
            background-image: url('../../../assets/right_arrow.svg');
          }
        }
      }
      .product-bd {
        .product-details {
          .detail-title {
            padding: 16px;
          }
          .detail-des {
            margin: 0 16px 10px;
            white-space: pre-line;
          }
          img {
            width: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }

  .dialog {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    display: none;

    .mask {
      position: absolute;
      top: 0px;
      width: 100%;
      height: 812px;
      background: rgba(0, 0, 0, 0.5);
    }

    .dialog_container {
      position: absolute;
      top: 348px;
      left: 0px;
      margin: 0px;
      width: 100%;
      height: 400px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      background: #fff;
      z-index: 9;

      .container-title {
        position: relative;
        width: 100%;
        height: 60px;
        .closeBtn {
          position: absolute;
          left: 8px;
          cursor: pointer;
          width: 40px;
          height: 100%;
        }
        .closeBtn:before {
          content: ' ';
          display: inline-block;
          vertical-align: middle;
          position: absolute;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: 24px;
          height: 24px;
          background-size: cover;
          background-image: url('../../../assets/close-btn.svg');
        }
      }

      .dialog__content {
        height: 340px;
        overflow: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }

  .skuDialog {
    .sku-dialog__hd {
      margin-bottom: 10px;
      padding: 0 16px;
      .sku-preview__image {
        width: 96px;
        height: 96px;
        margin-right: 12px;
        object-fit: cover;
      }

      .sku-preview {
        width: 100%;
        .sku-preview__info {
          flex: 1;

          .product-title {
            font-size: 20px;
            font-weight: bold;
          }

          .product-title,
          .product-sub-title {
            word-break: break-all;
          }

          .sku-price {
            text-align: right;
            color: #ffc107;
            .price-num {
              font-size: 22px;
              font-weight: bold;
            }
          }
        }
      }
    }
    .sku-dialog__bd {
      padding: 0 16px;
      .sku-item {
        padding: 10px 0;
        .sku-item__title {
          margin-bottom: 12px;
        }
        .sku-item__tags {
          flex-wrap: wrap;
          .sku-item__tag {
            font-size: 12px;
            display: inline-flex;
            align-items: center;
            padding: 0 10px;
            background-color: #f6f7f8;
            border-radius: 6px;
            box-sizing: border-box;
            margin-right: 6px;
            margin-bottom: 6px;
            line-height: 26px;
          }
        }
        .active {
          background-color: #e7e7e7;
        }
      }

      .sku-count {
        margin-top: 10px;
        padding: 10px 0;
        position: relative;

        .limit-num {
          color: #999999;
        }
      }

      .count-ctrl {
        font-size: 0;
        display: inline;
        & > div {
          font-size: 14px;
          display: inline-flex;
          box-sizing: border-box;
          height: 32px;
          justify-content: center;
          align-items: center;
          text-align: center;
          vertical-align: middle;
        }
        .count-ctrl__btn {
          font-size: 22px;
          color: #ccc;
        }
      }
    }
  }

  .shipping-dialog {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: none;

    .title-text {
      height: 100%;
      line-height: 64px;
      text-align: center;
      border-bottom: 1px solid #EBEEF5;
    }

    .dialog__content {
      .shipping-cell {
        min-height: 50px;
        border-bottom: 1px solid #EDEDED;
        color: #303133;
        .cell-title {
          width: 90px;
          flex-shrink: 0;
          color: #909399;
        }
      }
    }
  }
  .view-show {
    display: block;
  }
  .preview_ft {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 64px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    .page-ft__content {
      height: 100%;
      width: 375px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      position: relative;

      .content-border {
        border-top: 1px solid #e7e7e7;
      }

      .tab-item {
        width: 48px;
        text-align: center;
        font-size: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .tab-item__icon {
          width: 24px;
          height: 24px;
          margin-bottom: 2px;
          background-repeat: no-repeat;
          background-position: center;
          background-color: transparent;
          &.msg {
            background-size: 20px 18px;
            background-image: url('../../../assets/msg.svg');
          }
          &.shop {
            background-size: 16px 20px;
            background-image: url('../../../assets/shop.svg');
          }
        }
        .tab-item__text {
          font-size: 10px;
        }
      }
      .ft-btn {
        width: auto;
        min-width: 84px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        padding: 0 0.75em;
        border-radius: 8px;
        font-weight: 700;
        text-align: center;
      }
      .add-btn {
        color: #07c160;
        background-color: #eee;
      }
      .buy-btn {
        color: #fff;
        background-color: #07c160;
        margin-left: 8px;
      }
    }
  }
}
</style>
